'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VApp = undefined;

var _VApp = require('./VApp');

var _VApp2 = _interopRequireDefault(_VApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VApp = _VApp2.default;
exports.default = _VApp2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VApp/index.js
// module id = 180
// module chunks = 0